<style lang="less" scoped>
    .range-record-container {
        width: 100%;
        height: 100%;
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        .header-div {
            width: 100%;
            height: 200px;
            background: linear-gradient(143deg, #00B5B7 0%, #73D899 100%);
            .header-title-div {
                margin: 12px 20px;
                display: flex;
                .header-left-img-div {
                    height: 32px;
                    width: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .header-title {
                    height: 32px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 32px;
                    margin-left: 10px;
                }
            }
            .corp-title-div {
                margin-top: 28px;
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 36px;
                text-align: center;
            }
            .corp-abbr-title-div {
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                text-align: center;
            }
        }
        .record-list-div {
            flex: 1;
            background: #FFFFFF;
            border-radius: 30px;
            margin-top: -32px;
            display: flex;
            margin-bottom: 24px;
            flex-direction: column;
            overflow: hidden;
            .record-top-line-div {
                width: 73px;
                height: 5px;
                background: #D1D1D1;
                border-radius: 4px;
                opacity: 0.39;
                margin: 10px auto;
            }
            .record-list-title-div {
                height: 22px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
                line-height: 22px;
                margin-left: 20px;
                margin-bottom: 10px;
            }
            .record-list-scroll-div {
                flex: 1;
                overflow-y: auto;
            }
            .record-list-child-div {
                margin: 12px 20px 0 20px;
                background: #F4F4FB;
                border-radius: 13px;
                .record-show-line-div {
                    display: flex;
                    .left-station-div {
                        flex: 1;
                        height: 40px;
                        line-height: 40px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-size: 12px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                        margin-left: 20px;
                    }
                    .time-info-div {
                        height: 40px;
                        line-height: 40px;
                        font-size: 12px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #000000;
                    }
                    .right-icon-div {
                        margin-left: 10px;
                        height: 40px;
                        width: 20px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 12px;
                    }
                }
                .record-hide-info-div {
                    margin: 0px 20px;
                    padding-bottom: 16px;
                    .address-flex-div {
                        display: flex;
                        .address-icon-div {
                            width: 12px;
                            height: 24px;
                            margin-right: 10px;
                        }
                        .address-info-div {
                            flex: 1;
                            margin-right: 20px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            line-height: 24px;
                        }
                    }
                    .distance-time-info-div {
                        display: flex;
                        .map-icon-div {
                            width: 12px;
                            height: 20px;
                            margin-right: 10px;
                        }
                        .distance-time-value {
                            font-size: 12px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #000000;
                            line-height: 20px;
                            margin-right: 12px;
                        }
                    }
                    .pile-nums-money-div {
                        display: flex;
                        margin-top: 24px;
                        .pile-title {
                            font-size: 10px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #000000;
                            line-height: 38px;
                        }
                        .pile-num {
                            font-size: 10px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #04B6B6;
                            margin: 0 5px;
                            line-height: 38px;
                        }
                        .charge-money-div {
                            line-height: 32px;
                            font-size: 22px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #04B6B6;
                        }
                        .charge-unit-div {
                            font-size: 10px;
                            font-family: PingFangSC-Semibold, PingFang SC;
                            font-weight: 600;
                            color: #04B6B6;
                            line-height: 38px;
                            margin-left: 4px;
                        }
                    }
                    .start-info-tips-div {
                        margin-top: -10px;
                        display: flex;
                        .start-info {
                            font-size: 10px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #000000;
                        }
                        .parking-title {
                            margin-left: 4px;
                            font-size: 10px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #000000;
                        }
                    }
                }
            }
        }
        .record-list-scroll-div::-webkit-scrollbar {
            display: none;
        }
        .flex-center {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .no-records-img-div{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            .no-record-tips-div{
                margin-top: 32px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
            }
        }
    }
</style>

<template>
    <div class="range-record-container">
        <div class="header-div">
            <div class="header-title-div">
                <div class="header-left-img-div" @click="backToMain()">
                    <img src="../../assets/h5-img/direction-left.png" width="18" height="18">
                </div>
                <div class="header-title">范围记录</div>
            </div>
            <div class="corp-title-div">{{curSelCardInfo.dealerName}}</div>
            <div class="corp-abbr-title-div">简称：{{curSelCardInfo.dealAbbrName}}</div>
        </div>
        <div class="record-list-div">
            <div class="record-top-line-div"></div>
            <div class="record-list-title-div">范围明细</div>
            <div class="record-list-scroll-div" v-if="rangeList.length>0">
                <div class="record-list-child-div" v-for="(detail,index) in rangeList" v-bind:key="detail.id">
                    <div class="record-show-line-div" @click="updateShowDetail(detail,index)">
                        <div class="left-station-div">{{detail.stationName}}</div>
                        <div class="time-info-div">{{detail.stationDistance}}</div>
                        <div class="right-icon-div">
                            <img src="../../assets/h5-img/arrow-down-bold.png" width="11" height="7">
                        </div>
                    </div>
                    <div class="record-hide-info-div" v-if="detail.showHide">
                        <div class="address-flex-div">
                            <div class="address-icon-div flex-center">
                                <img src="../../assets/h5-img/location.png" width="9" height="11">
                            </div>
                            <div class="address-info-div">{{detail.stationAddr}}</div>
                        </div>
                        <div class="distance-time-info-div">
                            <div class="map-icon-div flex-center">
                                <img src="../../assets/h5-img/distance.png" width="11" height="11">
                            </div>
                            <div class="distance-time-value">{{detail.stationDistance}} </div>
                            <div class="map-icon-div flex-center">
                                <img src="../../assets/h5-img/time.png" width="11" height="11">
                            </div>
                            <div class="distance-time-value">预计{{parseInt(detail.predictTime)||'-'}}分钟</div>
                        </div>
                        <div class="pile-nums-money-div">
                            <div class="pile-title">直流</div>
                            <div class="pile-num">{{parseInt(detail.dcPileCount)||'0'}}</div>
                            <div class="pile-title">交流</div>
                            <div class="pile-num">{{parseInt(detail.acPileCount)||'0'}}</div>
                            <div class="flex-1"></div>
                            <div class="charge-money-div">{{detail.chargeAmt||'-'}}</div>
                            <div class="charge-unit-div">元/度</div>
                        </div>
                        <div class="start-info-tips-div">
                            <div class="start-info">{{detail.startChargeModeName||'-'}}</div>
                            <div class="flex-1"></div>
                            <div class="port-icon-div flex-center">
                                <img src="../../assets/h5-img/parking-lot.png" width="12" height="12">
                            </div>
                            <div class="parking-title">{{detail.parkRateName||'-'}}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="no-records-img-div" v-else>
                <img src="../../assets/h5-img/no-range.png" width="113" height="68">
                <div class="no-record-tips-div">没有找到其他的电站</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                rangeList: [],
                curAppH5Info:{},
                curSelCardInfo:{},
            }
        },
        methods: {
            init() {
                // 获取用户电卡储值列表
                this.getCardRangeList();
            },
            getCardRangeList(){
                let _ = this;
                const querInfo = {
                    corpNo:_.$C.corpNo,
                    userPhone:_.curSelCardInfo.useredBy,
                    dealNo:_.curSelCardInfo.dealerNo,
                    pageNum:0,
                    pageSize:99,
                    lon:this.curAppH5Info.curUserLon||0,
                    lat:this.curAppH5Info.curUserLat||0,
                };
                _.$U.showLoading(_);
                _.rangeList = [];
                _.$H.post(_, _.$A.h5.rangeList, querInfo).then(res => {
                    let resData = res.data.data || [];
                    resData.forEach(item=>{
                        if(item.stationDistance<1){
                            item.stationDistance = parseFloat(item.stationDistance*1000) + ' m';
                        }else{
                            item.stationDistance = parseFloat(item.stationDistance) + ' km';
                        }
                        _.rangeList.push(item);
                    })
                    _.$U.hideLoading(_);
                })
            },
            updateShowDetail(detail, index) {
                detail.showHide = !detail.showHide;
                this.$set(this.rangeList[index], detail);
                this.$forceUpdate();
            },
            // 返回列表页
            backToMain(){
                this.$router.push({
                    name: 'h5_chargeCardDetail'
                })
            },
        },
        mounted() {
            this.curSelCardInfo = this.$store.state.curSelChargeCardInfo;
            this.curAppH5Info = this.$store.state.curAppH5Info;
            this.init();
        }
    }
</script>